import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import chevron from 'common/assets/chevron_left-24px.svg';
import styles from './styles.module.scss';

const ButtonBack = ({label}) => {
  const history = useHistory();

  const handleClick = () => history.goBack();

  return (
    <div className={styles.backContainer} onClick={handleClick}>
      <div className={styles.label}>{label}</div>
      <img src={chevron} alt="arrow back" className={styles.arrow}/>
    </div>
  );
};

ButtonBack.propTypes = {
  label: PropTypes.string,
};

export default ButtonBack;
